import React, { useEffect, useState } from "react";
import { Box, Card, Typography, Button } from "@material-ui/core";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  checkinDetailSelector,
  learningResponseModalSelector,
  learningResponseSelector,
} from "Recoil/Checkins/selector";
import {
  checkinDetailsExpandState,
  checkinOverviewLoaderState,
  learningResponseModalState,
  surveyResponseState,
} from "Recoil/Checkins/atom";
import { useCheckinDetailGrid } from "Hooks/checkin/useCheckinDetailGrid";
import { DownloadDropDown } from "./Common";
import SelectField from "Components/formControls/HookFields/SelectField";
import { useStyles } from "./styles";
import AdaptiveModal from "Components/modal/Modal/AdaptiveModal";
import ViewResponses from "../ViewResponses";
import ExpandIcon from "Assets/images/expand.svg";
import CollapseIcon from "Assets/images/collapse.svg";
import DetailsGridView from "./DetailsGridView";
import { useHistory } from "react-router";

const RightPanel = ({ sortSelected, setSortSelected, selectedFrequency }) => {
  const classes = useStyles();
  const [expand, setExpand] = useRecoilState(checkinDetailsExpandState);
  const { surveyDetailsColumns, fetchSurveyDetailsColumns } =
    useCheckinDetailGrid();
  const history = useHistory();
  const loader = useRecoilValue(checkinOverviewLoaderState);
  const [sortOptions] = useState([
    { name: "Group by people" },
    { name: "Group by question" },
  ]);
  const { checkInType, checkinFrequencyDates, isTestSurvey } = useRecoilValue(
    checkinDetailSelector
  );

  // const [selectedFrequency, setSelectedFrequency] = useState(null);
  const [columnsState, setColumnsState] = useState([]);
  const learningResponseModal = useRecoilValue(learningResponseModalSelector);
  const setLearningResponseModal = useSetRecoilState(
    learningResponseModalState
  );
  const [surveyResponseData, setSurveyResponseData] =
    useRecoilState(surveyResponseState);
  const learningResponseData = useRecoilValue(learningResponseSelector);
  let checkinData = ["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)
    ? surveyResponseData
    : learningResponseData;

  // useEffect(() => {
  //   if (checkinFrequencyDates?.length > 0) {
  //     setSelectedFrequency(checkinFrequencyDates[0]);
  //   }
  // }, [checkinFrequencyDates]);

  useEffect(() => {
    if (history?.location?.state?.respondedUserId) {
      let data = surveyResponseData.slice();
      let index = data.findIndex(
        (d) => d.id === history?.location?.state?.respondedUserId
      );
      if (index >= 0)
        data[index] = {
          ...data[index],
          expanded: true,
        };
      setSurveyResponseData(data);
    }
  }, [history?.location?.state?.respondedUserId]);
  useEffect(() => {
    if (checkInType) {
      if (["SURVEY", "REQUESTFEEDBACK"].includes(checkInType)) {
        if (sortSelected === "Group by question") {
          const columns = isTestSurvey
            ? surveyDetailsColumns.filter((c) =>
                ["title", "questionType", "percentage"].includes(c.field)
              )
            : surveyDetailsColumns.filter((c) =>
                ["title", "questionType"].includes(c.field)
              );
          setColumnsState(columns);
        } else {
          const columns = surveyDetailsColumns.filter((c) =>
            checkInType === "SURVEY" && isTestSurvey
              ? ["name", "dueDate", "status", "percentage"].includes(c.field)
              : ["name", "dueDate", "status"].includes(c.field)
          );
          setColumnsState(columns);
        }
      } else {
        const columns = surveyDetailsColumns.filter((c) =>
          ["name", "dueDate", "status", "response"].includes(c.field)
        );
        setColumnsState(columns);
      }
    }
    // setExpand(false);
  }, [sortSelected, checkInType, selectedFrequency]);

  const expandAll = () => {
    const data = surveyResponseData.map((res) => ({
      ...res,
      expanded: !expand,
    }));
    setExpand((e) => !e);
    setSurveyResponseData(data);
  };

  return (
    <Box className={classes.rightSection}>
      <Card>
        <Box p={3}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box
              display="flex"
              alignItems="center"
              className={classes.headerSection}
            >
              <Typography
                variant="subtitle2"
                className="font-14 font-bold mr15"
              >
                {checkInType === "REQUESTFEEDBACK"
                  ? "Feedback"
                  : checkInType === "SURVEY"
                  ? "Survey"
                  : "Learning check-in"}
              </Typography>
              {["SURVEY", "REQUESTFEEDBACK"].includes(checkInType) && (
                <SelectField
                  defaultValue={sortSelected}
                  options={sortOptions}
                  onChange={(e) => setSortSelected(e.target.value)}
                  value={sortSelected}
                />
              )}

              {/* <FrequencyFilter
                selectedFrequency={selectedFrequency}
                setSelectedFrequency={setSelectedFrequency}
                checkinFrequencyDates={checkinFrequencyDates}
              /> */}
            </Box>
            <Box display="flex" alignItems="center">
              {["SURVEY", "REQUESTFEEDBACK"].includes(checkInType) ? (
                <Button
                  size="small"
                  color="primary"
                  className="mr10"
                  data-testid="handleExpand"
                  onClick={expandAll}
                >
                  {/* Expand all */}
                  {expand ? "Collapse all" : "Expand all"}
                  <img
                    src={expand ? CollapseIcon : ExpandIcon}
                    alt="expand all"
                    width="20px"
                    className="ml5"
                    
                  />
                </Button>
              ) : null}
              <DownloadDropDown selectedFrequency={selectedFrequency} />
            </Box>
          </Box>
          <DetailsGridView
            loader={loader}
            setExpand={setExpand}
            sortSelected={sortSelected}
            columnsState={columnsState}
            checkinData={checkinData}
            checkInType={checkInType}
            fetchColumn={fetchSurveyDetailsColumns}
            surveyResponseData={surveyResponseData}
            setSurveyResponseData={setSurveyResponseData}
            resPondedId={history?.location?.state?.respondedUserId}
          />
        </Box>
      </Card>

      {learningResponseModal && (
        <AdaptiveModal
          open={learningResponseModal}
          setOpen={setLearningResponseModal}
          handleClose={() => {
            setLearningResponseModal(false);
          }}
          size="sm"
          title="View responses"
          body={
            <ViewResponses
              handleClose={() => {
                setLearningResponseModal(false);
              }}
            />
          }
          showCancel={false}
          showOk={false}
        />
      )}
    </Box>
  );
};

export default RightPanel;
